import { MerchandisingRuleTypes, merchandisingRulesService } from 'src/services';
import { SyteProductType } from 'src/services/src/service/types/constants/syte-product-types';

export const MERCH_RULES_PAGE_SIZE = 100;

export async function fetchAllMerchRules({
  shopId,
  variantId,
  product,
}: {
  shopId: number;
  variantId: string;
  product?: SyteProductType[];
}): Promise<MerchandisingRuleTypes.MerchandiseRule[]> {
  const firstPage = await merchandisingRulesService.getRules({
    shopId,
    variantId,
    product,
    skip: 0,
    limit: MERCH_RULES_PAGE_SIZE,
  });

  const remainingPagesCount = Math.max(
    0,
    Math.ceil(firstPage.pagination.totalCount / MERCH_RULES_PAGE_SIZE) - 1
  );

  const remainingPages = await Promise.all(
    Array.from({ length: remainingPagesCount }, (_, pageIndex) =>
      merchandisingRulesService.getRules({
        shopId,
        variantId,
        product,
        skip: (pageIndex + 1) * MERCH_RULES_PAGE_SIZE,
        limit: MERCH_RULES_PAGE_SIZE,
      })
    )
  );

  return [
    ...firstPage.merchandisingRules,
    ...remainingPages.flatMap(page => page.merchandisingRules),
  ];
}
